var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Panel } from '../Panel';
/**
 * The panel is used to display all kinds of data on the ANWB website.
 * @deprecated this variant of Panel will no longer be supported in the future and is mapped to the new Panel building blocks. Please implement those building blocks directly.
 */
export const PanelStandard = (_a) => {
    var { children, dataTest = 'panel-standard', footer, icon, image, links, onClickTitle, sticker, subTitle, title = '', titleLink, titleLinkIcon, videoId } = _a, props = __rest(_a, ["children", "dataTest", "footer", "icon", "image", "links", "onClickTitle", "sticker", "subTitle", "title", "titleLink", "titleLinkIcon", "videoId"]);
    return (_jsxs(Panel, Object.assign({}, props, { variant: "informative", href: titleLink, dataTest: dataTest, children: [_jsx(Panel.Media, { image: image, videoId: videoId }), sticker && _jsx(Panel.Sticker, { children: sticker }), _jsx(Panel.Header, { icon: icon, onClick: onClickTitle, subTitle: subTitle, title: title, titleLinkIcon: titleLinkIcon }), _jsx(Panel.Content, { children: children }), _jsx(Panel.Links, { links: links, dataTest: dataTest }), _jsx(Panel.Footer, { children: footer })] })));
};
